import { render, staticRenderFns } from "./attachment-modal.vue?vue&type=template&id=89ddb02e&"
import script from "./attachment-modal.vue?vue&type=script&lang=js&"
export * from "./attachment-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports